import React, { useEffect, useState } from "react";
import { Image } from "@nubeteck/components";
import { LogoCenfotecPNG } from "src/assets";
import { LoginSVG } from "src/assets";
import {
  FlexContainerStyled,
  ImageContainerStyled,
  FormSection,
  SubHeadingStyled,
  Frame,
  LoginButtonContainer,
} from "./login.styled";
import { GoogleLogin, CredentialResponse } from "@react-oauth/google";
import { useLoginUserMutation } from "src/services";
import { useNavigate } from "react-router-dom";
import { Spin, Skeleton } from "antd";
import { useErrorLoginToast, useErrorGenericToast, useErrorUnauthorizedToast } from "src/constants";
import { getLoginPage } from "src/Api/content";
import { useLocale } from "src/i18n/localeContext";
import { StrapiError } from "../StrapiError";

const Login = () => {
  const [loginUser, { data, isLoading, isSuccess, error }] = useLoginUserMutation();
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const navigate = useNavigate();
  const showErrorLoginToast = useErrorLoginToast();
  const showErrorGenericToast = useErrorGenericToast();
  const showErrorUnauthorizedToast = useErrorUnauthorizedToast();
  const handleCallbackResponse = async (response: CredentialResponse) => {
    loginUser({ credential: response.credential });
  };
  const { locale } = useLocale();
  const [loginPage, setLoginPage] = useState<any>(null);
  const [hasError, setHasError] = useState<boolean>(false);
  useEffect(() => {
    if (isSuccess) {
      localStorage.setItem("token", data.data.admin ?? data.data.profesor ?? data.data.estudiante);
      let profiles = {};
      if (data.data.admin) profiles = { ...profiles, Admin: data.data.admin };
      if (data.data.estudiante) profiles = { ...profiles, Estudiante: data.data.estudiante };
      if (data.data.profesor) profiles = { ...profiles, Profesor: data.data.profesor };

      localStorage.setItem("profiles", JSON.stringify(profiles));

      localStorage.setItem("refreshToken", JSON.stringify(data.data.refreshToken));
      navigate("/");
    }
    if (error) {
      if ("status" in error) {
        const errStatus = "error" in error ? error.status : error.status;
        if (errStatus == 401) showErrorUnauthorizedToast();
        else showErrorLoginToast();
      }
    }
  }, [isSuccess, data, navigate, error, showErrorLoginToast, showErrorUnauthorizedToast]);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setLoginPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getLoginPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setLoginPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setLoginPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setLoginPage(null);
      }}
    />;
  }

  return (
    <Spin spinning={isLoading} size="large">
      <FlexContainerStyled style={{ justifyContent: "space-between" }}>
        <Frame>
          <FormSection>
            <Image src={LogoCenfotecPNG} width={145} preview={false} />
            <SubHeadingStyled>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (loginPage?.name || "AUTOSERVICIO")}</SubHeadingStyled>
            <LoginButtonContainer>
              <SubHeadingStyled>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (loginPage?.title || "INICIO DE SESIÓN")}</SubHeadingStyled>
              <GoogleLogin
                onSuccess={(credentialResponse) => {
                  handleCallbackResponse(credentialResponse);
                }}
                onError={() => {
                  showErrorGenericToast();
                }}
              />
            </LoginButtonContainer>
          </FormSection>
        </Frame>

        <ImageContainerStyled>
          <Image src={LoginSVG} width={250} preview={false} />
        </ImageContainerStyled>
      </FlexContainerStyled>
    </Spin>
  );
};

export default Login;
